export const importMapping = {
  heading: "Import mappings",
  description:
    "Mappings between FHIR resources and ElevanceHealth concepts used when importing FHIR data from other systems (i.e. via bulk import, provider connections and operations like $subit-data).",
  table_header: "Import mappings",
  table_columns: ["FHIR", "Maps To", "ElevanceHealth"],
  table_data: [
    {
      name: "AllergyIntolerance",
      values: [
        {
          type: "link",
          value: "AllergyIntolerance",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Allergy",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Allergy concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "Maps To" , "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart
                     ElevanceHealth.Web.Models.FhirInfoMappingPart
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Appointment",
      values: [
        {
          type: "link",
          value: "Appointment",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Encounter",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Encounter concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Basic",
      values: [
        {
          type: "link",
          value: "Basic",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Referral",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Referral concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "CarePlan",
      values: [
        {
          type: "link",
          value: "CarePlan",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "CareTaskGroup CareTask",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth CareTaskGroup, CareTask concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Claim",
      values: [
        {
          type: "link",
          value: "Claim",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Claim Medication",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Claim, Medication concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Condition",
      values: [
        {
          type: "link",
          value: "Condition",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Problem",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Problem concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Coverage",
      values: [
        {
          type: "link",
          value: "Coverage",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Insurance",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Insurance concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Device",
      values: [
        {
          type: "link",
          value: "Device",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "DeviceDataSource",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth DeviceDataSource concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "DiagnosticReport",
      values: [
        {
          type: "link",
          value: "DiagnosticReport",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Report LabReport",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Report, LabReport concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "DocumentReference",
      values: [
        {
          type: "link",
          value: "DocumentReference",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Report",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Report concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Encounter",
      values: [
        {
          type: "link",
          value: "Encounter",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Encounter Problem",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Encounter, Problem concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "ExplanationOfBenefit",
      values: [
        {
          type: "link",
          value: "ExplanationOfBenefit",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Claim Medication",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Claim, Medication concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "FamilyMemberHistory",
      values: [
        {
          type: "link",
          value: "FamilyMemberHistory",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "FamilyHistory",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth FamilyHistory concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Goal",
      values: [
        {
          type: "link",
          value: "Goal",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "CareTask",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth CareTask concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Immunization",
      values: [
        {
          type: "link",
          value: "Immunization",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "MedicationAdministration MedicationProfile",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description:
          "Maps the ElevanceHealth MedicationAdministration, MedicationProfile concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Location",
      values: [
        {
          type: "link",
          value: "Location",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Location",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Location concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Medication",
      values: [
        {
          type: "link",
          value: "Medication",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "MedicationProfile Order Medication",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description:
          "Maps the ElevanceHealth MedicationProfile, Order, Medication concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "MedicationAdministration",
      values: [
        {
          type: "link",
          value: "MedicationAdministration",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "MedicationAdministration MedicationProfile",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description:
          "Maps the ElevanceHealth MedicationAdministration, MedicationProfile concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "MedicationDispense",
      values: [
        {
          type: "link",
          value: "MedicationDispense",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Medication",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Medication concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "MedicationRequest",
      values: [
        {
          type: "link",
          value: "MedicationRequest",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Order",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Order concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Observation",
      values: [
        {
          type: "link",
          value: "Observation",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value:
            "LabObservation Observation DeviceDataContextWithDeviceDataPoints DeviceDataPoint",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description:
          "Maps the ElevanceHealth LabObservation, Observation, DeviceDataContextWithDeviceDataPoints, DeviceDataPoint concepts",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Organization",
      values: [
        {
          type: "link",
          value: "Organization",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Caregiver",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Caregiver concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Patient",
      values: [
        {
          type: "link",
          value: "Patient",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Patient RecordGroup",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Patient, RecordGroup concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "Map To", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value: 
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                     ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "multiline",
                  value:
                    `ElevanceHealth.Web.Models.FhirInfoMappingPart 
                    ElevanceHealth.Web.Models.FhirInfoMappingPart`,
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "image",
                  value: "",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Practitioner",
      values: [
        {
          type: "link",
          value: "Practitioner",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Caregiver",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Caregiver concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Procedure",
      values: [
        {
          type: "link",
          value: "Procedure",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Procedure",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Procedure concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "RelatedPerson",
      values: [
        {
          type: "link",
          value: "RelatedPerson",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "PatientAssociatedParty",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth PatientAssociatedParty concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "ServiceRequest",
      values: [
        {
          type: "link",
          value: "ServiceRequest",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "Order Referral",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth Order, Referral concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Specimen",
      values: [
        {
          type: "link",
          value: "Specimen",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "LabReportSpecimen LabReport",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description:
          "Maps the ElevanceHealth LabReportSpecimen, LabReport concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "Task",
      values: [
        {
          type: "link",
          value: "Task",
        },
        {
          type: "image",
          value: "",
        },
        {
          type: "text",
          value: "CareTask",
        },
      ],
      subgroup: {
        heading: "Imported resource",
        description: "Maps the ElevanceHealth CareTask concept",
        innerTable: {
          header: "From FHIR mappings",
          columns: ["FHIR", "ElevanceHealth"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value:
                    "ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
                {
                  type: "text",
                  value: "ElevanceHealth.Web.Models.FhirInfoMappingPart",
                },
              ],
            },
          ],
        },
      },
    },
  ],
};
